import React, { useEffect } from "react";

import useComponentVisible from "hooks/useComponentVisible"

const DropdownWrapper = (props) => {
  const { ref, isComponentVisible } = useComponentVisible(true);

  useEffect(() => {
    if (!isComponentVisible) {
      props.hideDropdown();
    }
  }, [isComponentVisible]);

  return (
    <div ref={ref}>
      {isComponentVisible && (props.children)}
    </div>
  );
}

export default DropdownWrapper;
